import type {
  TaskTrackerBoardAccessMember,
  TaskTrackerBoardAccessMode,
  TaskTrackerProjectMember,
} from '../store/taskTracker.types'

export type TaskTrackerAccessibleUser = {
  userId: number
  name: string
  email: string | null
  phone: string | null
  avatarPath: string | null
  roleTitle: string | null
}

const formatUserName = (name: string) => name.trim() || 'Без имени'

export const mapProjectMemberToAccessibleUser = (
  member: TaskTrackerProjectMember,
): TaskTrackerAccessibleUser | null => {
  if (!Number.isFinite(member.userId) || member.userId <= 0) return null

  return {
    userId: member.userId,
    name: formatUserName(member.user?.name ?? ''),
    email: member.user?.email ?? null,
    phone: member.user?.phone ?? null,
    avatarPath: member.user?.avatarPath ?? null,
    roleTitle: member.role?.title?.trim() || null,
  }
}

export const mapBoardAccessMemberToAccessibleUser = (
  member: TaskTrackerBoardAccessMember,
): TaskTrackerAccessibleUser | null => {
  if (!Number.isFinite(member.userId) || member.userId <= 0) return null

  return {
    userId: member.userId,
    name: formatUserName(member.user?.name ?? ''),
    email: member.user?.email ?? null,
    phone: member.user?.phone ?? null,
    avatarPath: member.user?.avatarPath ?? null,
    roleTitle: null,
  }
}

export const resolveBoardAccessibleUsers = (
  accessMode: TaskTrackerBoardAccessMode,
  selectedMembers: TaskTrackerBoardAccessMember[],
  projectMembers: TaskTrackerProjectMember[],
): TaskTrackerAccessibleUser[] => {
  const source =
    accessMode === 'all_project_members'
      ? projectMembers
          .map(mapProjectMemberToAccessibleUser)
          .filter((item): item is TaskTrackerAccessibleUser => item != null)
      : selectedMembers
          .map(mapBoardAccessMemberToAccessibleUser)
          .filter((item): item is TaskTrackerAccessibleUser => item != null)

  const uniqueByUserId = new Map<number, TaskTrackerAccessibleUser>()
  source.forEach((user) => {
    uniqueByUserId.set(user.userId, user)
  })

  return Array.from(uniqueByUserId.values()).sort((left, right) =>
    left.name.localeCompare(right.name, 'ru'),
  )
}
